import React from "react"
import Cabecalho from "../Cabecalho"
import { ParametrosDeliveryContextProvider } from "./context/ParametrosDeliveryContextProvider"
import { ParametrosAvancadosContextProvider } from "./context/ParametrosAvancadosContextProvider"
import { ParametrosClienteFielContextProvider } from "./context/ParametrosClienteFielContextProvider"
import { ParametrosIntegracaoContextProvider } from "./context/ParametrosIntegracaoContextProvider"
import { FormularioParametrosDelivery } from "./components/FormularioParametrosDelivery"
import { FormularioParametrosAvancados } from "./components/FormularioParametrosAvancados"
import { FormularioParametrosClienteFiel } from "./components/FormularioParametrosClienteFiel"
import { FormularioParametrosIntegracao } from "./components/FormularioParametrosIntegracao"

export function IndexParametrosDelivery() {
    return (
        <ParametrosDeliveryContextProvider>
            <Cabecalho pagina="Parâmetros do Delivery" />
            <FormularioParametrosDelivery />
        </ParametrosDeliveryContextProvider>
    )
}

export function IndexParametrosAvancados() {
    return (
        <ParametrosAvancadosContextProvider>
            <Cabecalho pagina="Parâmetros Avançados" />
            <FormularioParametrosAvancados />
        </ParametrosAvancadosContextProvider>
    )
}

export function IndexParametrosClienteFiel() {
    return (
        <ParametrosClienteFielContextProvider>
            <Cabecalho pagina="Parâmetros — Cliente Fiel" />
            <FormularioParametrosClienteFiel />
        </ParametrosClienteFielContextProvider>
    )
}

export function IndexParametrosIntegracao() {
    return (
        <ParametrosIntegracaoContextProvider>
            <Cabecalho pagina="Parâmetros de Integração" />
            <FormularioParametrosIntegracao />
        </ParametrosIntegracaoContextProvider>
    )
}
